import type { CodeBlockSuggestion, DocumentLocationLink } from '@aline/common';
import { createMarkdownLocationLink } from '@aline/common';
import type { AlineClientEditor } from 'src/layout-engine';

import { parseLocation } from './parseLocation';
import type { SelectedReferenceWithDocumentId } from './parseLocation';

export function getReferenceFromSuggestion(
  editor: AlineClientEditor,
  suggestion: CodeBlockSuggestion
): SelectedReferenceWithDocumentId | null {
  const locationString: DocumentLocationLink = createMarkdownLocationLink(
    suggestion.documentId,
    suggestion.versionId,
    suggestion.locationId
  );
  return parseLocation(locationString, suggestion.original, editor);
}

export type AiReference = SelectedReferenceWithDocumentId;
